import React, { useEffect, useState } from 'react';
import { Globe, ExternalLink } from 'lucide-react';

// Test module: pre-rendered 360° tour of the Újezd junction (Blender model) next to real Street View.
// The tour is a static site in uploads/maps3d/ujezd, served by the backend at /maps3d/ujezd/ (login required).
const TOUR_URL = '/maps3d/ujezd/';
const card = { backgroundColor: '#FFF', borderRadius: '12px', border: '1px solid #E0E0E0' };

const Maps3D = () => {
  const [state, setState] = useState('loading');   // loading | ready | missing

  useEffect(() => {
    let cancelled = false;
    fetch(`${TOUR_URL}data.json`, { credentials: 'include' })
      .then((res) => { if (!cancelled) setState(res.ok ? 'ready' : 'missing'); })
      .catch(() => { if (!cancelled) setState('missing'); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div>
      <div style={{ ...card, padding: '14px 18px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        <Globe size={22} color="#E53935" aria-hidden />
        <div style={{ flex: '1 1 260px' }}>
          <h1 style={{ margin: 0, fontSize: '20px', color: '#333' }}>Testování map</h1>
          <div style={{ fontSize: '13px', color: '#666' }}>
            Zkušební modul: 3D model okolí křižovatky u Újezdu (Trmice) z otevřených dat, vedle skutečného Street View a leteckého snímku.
          </div>
        </div>
        {state === 'ready' && (
          <a href={TOUR_URL} target="_blank" rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '9px 14px', border: '1px solid #E0E0E0', borderRadius: '8px', color: '#333', textDecoration: 'none', fontSize: '14px' }}>
            <ExternalLink size={16} aria-hidden /> Otevřít celou obrazovku
          </a>
        )}
      </div>

      {state === 'missing' && (
        <div role="status" style={{ ...card, padding: '24px', color: '#666' }}>
          Mapa zatím není nahraná na server (složka <code>uploads/maps3d/ujezd</code>).
        </div>
      )}
      {state === 'ready' && (
        <iframe title="Testování map: 3D model a Street View" src={`${TOUR_URL}?embed=1`} allowFullScreen
          style={{ ...card, width: '100%', height: 'calc(100vh - 190px)', minHeight: '620px', display: 'block' }} />
      )}
    </div>
  );
};

export default Maps3D;
